import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, SparklesIcon } from 'lucide-react';
interface CongressShortcutProps {
  /** Hidden while the congress section itself is in view. */
  hidden: boolean;
}

/** Floating, gently animated shortcut to the ESHRE 2027 congress use case — on every page. */
export function CongressShortcut({
  hidden
}: CongressShortcutProps) {
  const goTo = () => {
    document.getElementById('congress')?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <AnimatePresence data-id="element-248" data-mp="249emjx3z5hhk">
      {!hidden && <motion.div key="congress-shortcut" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.35,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed bottom-5 left-5 z-40 sm:bottom-6 sm:left-6" data-id="element-249" data-mp="1zhwmrcdotmy6">
          <motion.button type="button" onClick={goTo} animate={{
        y: [0, -4, 0]
      }} transition={{
        duration: 2.6,
        repeat: Infinity,
        ease: 'easeInOut'
      }} whileHover={{
        scale: 1.04
      }} whileTap={{
        scale: 0.97
      }} aria-label="Go to the ESHRE 2027 congress use case" className="group relative inline-flex items-center gap-2.5 rounded-full bg-[var(--brand)] py-2.5 pl-2.5 pr-4 text-[13px] font-bold text-white shadow-[0_18px_40px_-14px_rgba(0,93,170,0.7)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)] focus-visible:ring-offset-2" data-id="element-250" data-mp="2n7h45qu70c5c">
            <motion.span aria-hidden="true" className="absolute inset-0 rounded-full ring-2 ring-[var(--brand)]" animate={{
          scale: [1, 1.18],
          opacity: [0.6, 0]
        }} transition={{
          duration: 1.8,
          repeat: Infinity,
          ease: 'easeOut'
        }} data-id="element-251" data-mp="2ofmq94l6go6q" />
            <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/15" data-id="element-252" data-mp="8p0j6jru9mpp">
              <motion.span className="flex" animate={{
            rotate: [0, 18, -12, 0]
          }} transition={{
            duration: 2.6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-253" data-mp="dnlh2cjmbuaz">
                <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-254" data-mp="2acs35irsuut" />
              </motion.span>
            </span>
            <span className="flex flex-col items-start leading-tight" data-id="element-255" data-mp="3thfm04pztf8q">
              <span className="text-[9.5px] font-bold uppercase tracking-[0.16em] text-white/70" data-id="element-256" data-mp="uza9l6f5qnmi">ESHRE 2027 · for Ferring</span>
              <span data-id="element-257" data-mp="pzxbtqmqzw55">Explore the IVF Pulse</span>
            </span>
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-258" data-mp="q2jkjtldkhoy" />
          </motion.button>
        </motion.div>}
    </AnimatePresence>;
}